export default __webpack_public_path__ + "static/media/3931.68469fce.png";